import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
const IntroSection = () => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) {
            setVisible(true);
            observer.disconnect();
        } }, { threshold: 0.2 });
        if (ref.current)
            observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);
    return (_jsx("section", { id: "about", className: "bg-section-alt py-24 md:py-32", children: _jsxs("div", { className: "container mx-auto px-6", ref: ref, children: [_jsxs("div", { className: "max-w-3xl mx-auto text-center", style: {
                        opacity: visible ? 1 : 0,
                        filter: visible ? "blur(0px)" : "blur(4px)",
                        transform: visible ? "translateY(0)" : "translateY(20px)",
                        transition: "opacity 0.7s cubic-bezier(0.16,1,0.3,1), transform 0.7s cubic-bezier(0.16,1,0.3,1), filter 0.7s cubic-bezier(0.16,1,0.3,1)",
                    }, children: [_jsx("p", { className: "uppercase tracking-[0.25em] text-sm font-semibold mb-5 text-brand-gradient", children: "The Method" }), _jsxs("h2", { className: "font-sans font-black text-foreground text-4xl md:text-5xl mb-8", children: ["Rino trains your mind", _jsx("br", {}), "to master your body"] }), _jsx("p", { className: "text-foreground/65 text-lg leading-relaxed", children: "Most sexual problems in healthy men under 40 are rooted in the mind, not the body. Stress, performance anxiety, and conditioned habits quietly erode your natural capacity for pleasure and connection. Rino uses guided sexual meditation rooted in cognitive behavioral science to rewire those patterns from the inside out." })] }), _jsx("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-6 mt-16 max-w-5xl mx-auto", children: [
                        {
                            num: "01",
                            title: "Listen",
                            desc: "Put on your headphones and find a private space. Follow the guide's voice through each session.",
                            delay: "0s",
                        },
                        {
                            num: "02",
                            title: "Feel",
                            desc: "Tune in to the signals your body has always been sending. Learn to read them clearly.",
                            delay: "0.12s",
                        },
                        {
                            num: "03",
                            title: "Transform",
                            desc: "Session by session, rebuild the mind-body connection that unlocks lasting change.",
                            delay: "0.24s",
                        },
                    ].map((item) => (_jsxs("div", { className: "bg-surface-raised border border-border rounded-2xl p-8", style: {
                            opacity: visible ? 1 : 0,
                            transform: visible ? "translateY(0)" : "translateY(24px)",
                            transition: `opacity 0.7s cubic-bezier(0.16,1,0.3,1) ${item.delay}, transform 0.7s cubic-bezier(0.16,1,0.3,1) ${item.delay}`,
                        }, children: [_jsx("span", { className: "text-brand-gradient font-black text-4xl", children: item.num }), _jsx("h3", { className: "font-sans font-black text-foreground text-2xl mt-4 mb-3", children: item.title }), _jsx("p", { className: "text-foreground/55 text-base leading-relaxed", children: item.desc })] }, item.num))) })] }) }));
};
export default IntroSection;
